<p>uptime-server works!</p>
